/** Formatting shared by the outbound-calls page and its tables. */

export const ms = (n: number) =>
  n >= 1000 ? `${(n / 1000).toFixed(2)} s` : `${Math.round(n)} ms`;

export const pct = (n: number) => `${(n * 100).toFixed(1)} %`;

/** Human labels for the integrations we record. Unknown groups show their raw key. */
const GROUP_LABELS: Record<string, string> = {
  provalliance: "Provalliance",
  calendly: "Calendly",
  custom_api: "APIs clients",
  mcp: "Serveurs MCP",
  browser: "Navigateur (par domaine)",
};

export const groupLabel = (key: string) => GROUP_LABELS[key] || key;
